// Installierbare Web-App (PWA): Service Worker, Installationsaufforderung, Plattform-Erkennung

let deferredPrompt = null;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn());

export const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

// iPadOS meldet sich als Mac, hat aber einen Touchscreen
export const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

// Android/Chrome liefert eine echte Installationsaufforderung, iOS nicht
export const canPromptInstall = () => deferredPrompt !== null;

export const promptInstall = async () => {
  if (!deferredPrompt) return false;
  const event = deferredPrompt;
  deferredPrompt = null;
  notify();
  event.prompt();
  const { outcome } = await event.userChoice;
  return outcome === 'accepted';
};

export const subscribeInstall = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const registerPWA = () => {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    notify();
  });

  // Als App gestartet: Browser bitten, die gespeicherten Szenarien nicht automatisch zu löschen
  if (isStandalone() && navigator.storage?.persist) {
    navigator.storage.persist().catch(() => {});
  }

  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch((error) => {
        console.error('Service Worker konnte nicht registriert werden:', error);
      });
    });
  }
};
